import { JSX } from 'react';
import { C03HeadlineCTAProps } from './C03HeadlineCTA.types';
import { Anchor, GoldBar } from '@ahc-digital/component-library';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';
import { getCheckbox, getDroplink } from '@/shared/param-utils';

const Default = (props?: C03HeadlineCTAProps): JSX.Element => {
  const id = props?.params?.RenderingIdentifier;
  const { renderLink } = useConditionalRendering();
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  const shouldDisplayGoldBar = getCheckbox(props?.rendering?.params?.ShouldDisplayGoldBar);

  return (
    <>
      {shouldDisplayGoldBar && (
        <GoldBar
          shouldDisplayGoldBar={shouldDisplayGoldBar}
          goldBarAlignment={getDroplink(props?.rendering?.params?.GoldBarAlignment, 'left')}
        />
      )}
      <Anchor id={id} variant="solid1" size="medium" data-component={marketingRenderingName}>
        {renderLink(props?.fields?.CTA)}
      </Anchor>
    </>
  );
};

export default checkDatasourceForRendering<C03HeadlineCTAProps>(Default);
